// Keeps the site working when a browser translator (Google Translate, Edge, Firefox)
// is active. Those tools replace text nodes with their own <font> elements, so when
// React later removes or inserts next to a node it rendered, the node is no longer
// where React expects and the DOM call throws, which in React 18 blanks the page.
// These guards turn that into a no-op with a warning instead of a crash.
// Based on the workaround from https://github.com/facebook/react/issues/11538
export function installTranslationGuard() {
  if (typeof Node !== 'function' || !Node.prototype) return;

  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function removeChild(child) {
    if (child.parentNode !== this) {
      console.warn('Skipped removing a node that a translation tool moved', child);
      return child;
    }
    return originalRemoveChild.call(this, child);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function insertBefore(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      console.warn('Skipped inserting before a node that a translation tool moved', referenceNode);
      return newNode;
    }
    return originalInsertBefore.call(this, newNode, referenceNode);
  };
}
